<template>
  <div :class="['pluck-error-401', $i18n.locale]">
    <div class="error-container">
      <h1 @click="goHome">
        <i class="icon icon--logo-horizontal"></i>
      </h1>
      <div class="error-wrap">
        <div class="error-img">
          <asset-error-pluck-401 />
        </div>
        <div class="error-text">
          <h2>Check</h2>
          <h3 v-html="$t('error.pluck401.title')"></h3>
          <p v-html="$t('error.pluck401.description')"></p>
          <div class="button">
            <ui-button :primary2="true"
                       :size="'xlarge'"
                       @click="goHome">{{ $t('error.pluck401.button') }}</ui-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { goHome } from '@/libs/utils'

import UiButton from '@/components/ui/UiButton'
import AssetErrorPluck401 from '@/assets/img/error/pluck401'

export default {
  name: 'ErrorPluck401',
  components: {
    UiButton,
    AssetErrorPluck401
  },
  methods: {
    goHome () {
      goHome()
    }
  }
}
</script>

<style lang="scss" scoped>
.pluck-error-401 {
  position: fixed;
  width: 100%;
  height: 100%;
  background-color: #F4F4F1;
  overflow: auto;
  z-index: 1000000000000;
  box-shadow: 0 8px 15px 0 rgba(0, 0, 0, 0.16), 0 0 0 1px rgba(0, 0, 0, 0.16);

  .error-container {
    position: relative;
    width: 100%;
    height: 100%;
    min-width: 1120px;
    min-height: 563px;
  }

  h1 {
    position: absolute;
    top: 15px;
    left: 15px;
    cursor: pointer;
  }

  .error-wrap {
    @include positionXYcenter;
    width: 1050px;
    height: 563px;

    .error-text {
      @include positionYcenter;
      padding-left: 100px;

      h2 {
        width: 280px;
        height: 80px;
        background: url('../../assets/img/error/asset--check.svg') no-repeat;
        color: transparent;
        margin: 20px 20px 0 20px;
      }

      h3 {
        font-size: 22px;
        line-height: 1.3;
        color: #00a2c2;
        font-weight: 500;
        margin: 30px 20px 20px 20px;
      }

      p {
        font-size: 14px;
        line-height: 1.8;
        color: #666666;
        margin: 20px;

        & /deep/ span {
          display: block;
          margin-top: -3px;
          font-size: 13px;
        }
      }

      .button {
        margin: 33px 20px 25px;

        button {
          padding: 0 18px;
        }
      }
    }

    .error-img {
      @include positionYcenter;
      right: 0;
      margin: 60px 10px;
    }
  }
}
</style>
